import React, { useEffect, useState, useRef } from 'react';
import { PostRequest, GetRequest } from 'components/common';
import { AskConfirm, ConfirmPopup } from 'components/ConfirmPopup.jsx';

const QuoteBuilderManagePanel = ({}) => {
  const [attributes, setAttributes] = useState({});
  const confirmPopupRef = useRef({});
  const requestInProgress = useRef(false);

  const onUserQuoteCurrencyChanged = (msg) => {
    let newCurrency = msg.detail;

    if(requestInProgress.current) { return; }
    requestInProgress.current = true;

    PostRequest({
      url: `/quote-builder/${window.drawing_id}/${window.drawing_slug}/${window.user_quote.id}/set-currency/${newCurrency}`,
      data: {
      },
      callback: (data) => {
        location.reload();
      }
    })
  }

  const getSummary = () => {
    if(window.user_quote_id != undefined) {
      if(requestInProgress.current) { return; }
      requestInProgress.current = true;

      GetRequest({
        url: `/quote-builder/my-quotes/${window.user_quote_id}/summary`,
        callback: (data) => {
          setAttributes(data);
          requestInProgress.current = false;
        }
      })
    }
  }

  const onSectionResultUpdated = () => {
    getSummary();
  }

  const setStatusConfirm = (e) => {
    let newValue = e.target.value;

    if(newValue == 'finalized') {
      AskConfirm(
        confirmPopupRef,
        t('quote_builder.confirm_finalized'),
        () => {
          PostRequest({
            url: `/quote-builder/${window.drawing_id}/${window.drawing_slug}/${window.user_quote.id}/finalize`,
            data: {
            },
            callback: (data) => {
              location.replace(data.redirect_to);
            }
          })

        }
      );
    }
  };
  const isTotalPriceSet = () => {
    return attributes.price_for_one_formatted != undefined && attributes.total_presented != undefined && attributes.price_for_one_formatted != '' && attributes.total_presented != '';
  }

  useEffect(() => {
    document.addEventListener('quote_builder.section_result_updated', onSectionResultUpdated);
    return () => { document.removeEventListener('quote_builder.section_result_updated', onSectionResultUpdated);}
  }, []);

 useEffect(() => {
    document.addEventListener('quote_builder.currency_changed', onUserQuoteCurrencyChanged);
    return () => { document.removeEventListener('quote_builder.currency_changed', onUserQuoteCurrencyChanged);}
  }, []);

  useEffect( () => {
    var event = new CustomEvent('quote_builder.total_presented_changed', { "detail": attributes.total_presented });
    document.dispatchEvent(event);

  }, [attributes.total_presented])

  const aggregatedTotalRows = () => {
    let res = [];

    for (let [title, values] of Object.entries(attributes.aggregated_totals)) {
      let isProfitMargin = false;
      for (let [key, value] of Object.entries(values)) {
        if (key == '_key' && value == 'profit_margin_general') { isProfitMargin = true}
      }

      if(!isProfitMargin) {
        res.push(
          <tr key={`title_${title}`}>
            <th colSpan="2" className="aggregatedTotalRowTitle"> {title}
            </th>
          </tr>);

        for (let [key, value] of Object.entries(values)) {
          if(key != '_total' && key != '_key' && key != '_user_quote_nav_section_label') {
            res.push(
              <tr key={`key_${key}`}>
                <td>  &nbsp; &nbsp; {key} </td>
                <td align="right" > {value} </td>
              </tr>);
          }
        }

        res.push(
          <tr key={`title_${title}_total`}>
            <td> &nbsp; &nbsp; {t('quote_builder.total')} </td>
            <td align="right" > <strong> {values._total} </strong> </td>
          </tr>);
      }
    }

      res.push(<tr key='empty'>
        <th colSpan="2"> &nbsp; </th>
      </tr>);

    return res;
  }

  const profitMarginTitle = () => {
    for (let [title, values] of Object.entries(attributes.aggregated_totals)) {
      for (let [key, value] of Object.entries(values)) {
        if (key == '_key' && value == 'profit_margin_general') { return title }
      }
    }
  }

  const resultTotalRows = () => {
    if(attributes.total_presented == attributes.total_without_margin_presented) {
        return (<>
          <tr key="total_manufacturing">
            <td> <strong> {t('quote_builder.total_manufacturing')} </strong>  </td>
            <td align="right">  <strong> {attributes.total_presented} </strong>  </td>
          </tr>

          <tr key="profit_margin">
            <td>
              <strong> {t('quote_builder.profit_margin')}
              </strong>
            </td>
            <td align="right"> <strong> 0 </strong> &nbsp; <a href="#profit_margin_general"> <i className="fa fa-pencil-square-o" aria-hidden="true"></i> {t('quote_builder.edit')} </a> </td>
          </tr>

          <tr key="total_quote">
            <td> <strong> {t('quote_builder.total')} </strong>  </td>
            <td align="right">  <strong> {attributes.total_presented} </strong>  </td>
          </tr>

          <tr key="price_for_one">
            <td> <strong> {t('quote_builder.price_for_one')} </strong>  </td>
            <td align="right">  {attributes.price_for_one_formatted}  </td>
          </tr>
        </>)
      }

      return (<>
        <tr key="total_manufacturing">
          <td> <strong> {t('quote_builder.total_manufacturing')} </strong>  </td>
          <td align="right">  <strong> {attributes.total_without_margin_presented} </strong>  </td>
        </tr>

        <tr key="profit_margin">
          <td> <strong> {profitMarginTitle()} </strong> </td>
          <td align="right">  <strong> {attributes.profit_margin_presented} </strong>  </td>
        </tr>

        <tr key="total_quote">
          <td> <strong> {t('quote_builder.total')} </strong>  </td>
          <td align="right">  <strong> {attributes.total_presented} </strong>  </td>
        </tr>

        <tr key="price_for_one">
          <td> <strong> {t('quote_builder.price_for_one')} </strong>  </td>
          <td align="right">  {attributes.price_for_one_formatted}  </td>
        </tr>
      </>)
  }

  return (
    <> <ConfirmPopup myRef={confirmPopupRef} />
      <table className="table table-bordered table-striped">
        <tbody>
          <tr key="status">
            <td>
              <strong> {t('quote_builder.quote_status')} </strong>
            </td>

            <td align="right">
              <select value={attributes.status}
                onChange={setStatusConfirm}
                disabled={!isTotalPriceSet()}
                className="form-control narrow_form_element"
              >
                <option key='draft' value='draft'> {t('quote_builder.draft')} </option>
                <option key='finalized' value='finalized'> {t('quote_builder.finalized')} </option>
              </select>
            </td>

            </tr>
            { isTotalPriceSet() && (
              <>
                {aggregatedTotalRows()}
                {resultTotalRows()}
                <tr key="pdf">
                   <td colSpan="2">
                      <div className="float-right">
                        <a href="?download=pdf" target='_blank'> <i className="fa fa-file-pdf-o" aria-hidden="true"></i> PDF </a>
                      </div>
                    </td>
                </tr>
              </>
            )}
        </tbody>
      </table>
    </>
  );
}

export default QuoteBuilderManagePanel;
